import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import EditableField from 'app/components/EditableField';
import ApiCalls from 'app/utils/apiCalls';

const saveClinicInfo = (clinicInfo: string) => ApiCalls.saveClinicInfo({ clinicInfo });

export default function ClinicInfoSetting() {
  const intl = useIntl();
  const [reportInfo, setReportInfo] = useState<{ clinicInfo?: string } | null>(null);

  useEffect(() => {
    ApiCalls.getReportInfo(false).then((response: any) => setReportInfo(response.data.reportInfo));
  }, []);

  return (
    <EditableField
      type="textarea"
      placeholder={intl.formatMessage({ id: 'monitoring.owner' })}
      text={reportInfo?.clinicInfo}
      onTextChange={saveClinicInfo}
    />
  );
}
